import ChangePasswordPrefs from './ChangePasswordPrefs'

export default ChangePasswordPrefs
